import { GeometryElement } from "../core/GeometryElement";
import { BufferUsage } from "../../RenderEngine/RenderEnum/BufferTargetType";
import { MeshTopology } from "../../RenderEngine/RenderEnum/RenderPologyMode";
import { DrawType } from "../../RenderEngine/RenderEnum/DrawType";
import { IndexFormat } from "../../RenderEngine/RenderEnum/IndexFormat";
import { VertexMesh } from "../../RenderEngine/RenderShader/VertexMesh";
import { Laya3DRender } from "../RenderObjs/Laya3DRender";
export class SubMeshInstanceBatch extends GeometryElement {
    static __init__() {
        SubMeshInstanceBatch.instance = new SubMeshInstanceBatch();
    }
    constructor() {
        super(MeshTopology.Triangles, DrawType.DrawElementInstance);
        this.instanceWorldMatrixData = new Float32Array(SubMeshInstanceBatch.maxInstanceCount * 20);
        this.instanceSimpleAnimatorData = new Float32Array(SubMeshInstanceBatch.maxInstanceCount * 4);
        this.indexFormat = IndexFormat.UInt16;
        this.instanceWorldMatrixBuffer = Laya3DRender.renderOBJCreate.createVertexBuffer3D(this.instanceWorldMatrixData.length * 4, BufferUsage.Dynamic, false);
        this.instanceWorldMatrixBuffer.vertexDeclaration = VertexMesh.instanceWorldMatrixDeclaration;
        this.instanceWorldMatrixBuffer.instanceBuffer = true;
        this.instanceSimpleAnimatorBuffer = Laya3DRender.renderOBJCreate.createVertexBuffer3D(this.instanceSimpleAnimatorData.length * 4, BufferUsage.Dynamic, false);
        this.instanceSimpleAnimatorBuffer.vertexDeclaration = VertexMesh.instanceSimpleAnimatorDeclaration;
        this.instanceSimpleAnimatorBuffer.instanceBuffer = true;
    }
    _updateRenderParams(state) {
    }
}
SubMeshInstanceBatch.maxInstanceCount = 1024;
